"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.files = {
    "name": "hierarchies",
    "birthtime": "2018-08-04T13:11:35.020Z",
    "size": 4096,
    "type": "dir",
    "children": [
        {
            "name": "Example-files",
            "birthtime": "2018-08-04T13:11:35.024Z",
            "size": 4096,
            "type": "dir",
            "children": [
                {
                    "name": "fs.d3.json",
                    "birthtime": "2018-08-04T13:11:35.024Z",
                    "size": 143249,
                    "type": "file"
                },
                {
                    "name": "stackoverflow",
                    "birthtime": "2018-08-04T13:11:35.696Z",
                    "size": 4096,
                    "type": "dir",
                    "children": [
                        {
                            "name": "LDA24.d3.json",
                            "birthtime": "2018-08-04T13:11:35.008Z",
                            "size": 7753933,
                            "type": "file"
                        },
                        {
                            "name": "PCA12.d3.json",
                            "birthtime": "2018-08-04T13:11:35.016Z",
                            "size": 5870871,
                            "type": "file"
                        },
                        {
                            "name": "_SVD24.d3.json",
                            "birthtime": "2018-08-04T13:11:35.020Z",
                            "size": 6087509,
                            "type": "file"
                        }
                    ]
                },
                {
                    "name": "flare.d3.csv",
                    "birthtime": "2018-08-04T13:11:35.024Z",
                    "size": 7989,
                    "type": "file"
                },
                {
                    "name": "sample.treeml.xml",
                    "birthtime": "2018-08-04T13:11:35.028Z",
                    "size": 21342,
                    "type": "file"
                },
                {
                    "name": "sample.skos.xml",
                    "birthtime": "2018-08-04T13:11:35.028Z",
                    "size": 1270700,
                    "type": "file"
                },
            ]
        },
        {
            "name": "Open-Tree-of-Life",
            "birthtime": "2018-08-03T21:44:46.888Z",
            "size": 4096,
            "type": "dir",
            "children": [
                {
                    "name": "eukaryota.d3.json",
                    "birthtime": "2018-08-03T14:49:58.959Z",
                    "size": 60162984,
                    "type": "file"
                },
                {
                    "name": "embryophyta.d3.json",
                    "birthtime": "2018-08-03T18:23:18.199Z",
                    "size": 44663266,
                    "type": "file"
                },
                {
                    "name": "metazoa.d3.json",
                    "birthtime": "2018-08-03T14:50:14.923Z",
                    "size": 109320174,
                    "type": "file"
                },
                {
                    "name": "vertebrata.d3.json",
                    "birthtime": "2018-08-03T19:35:45.666Z",
                    "size": 177541402,
                    "type": "file"
                },
                {
                    "name": "lophotrochozoa.d3.json",
                    "birthtime": "2018-08-03T18:19:03.648Z",
                    "size": 3729039,
                    "type": "file"
                },
                {
                    "name": "araneae.d3.json",
                    "birthtime": "2018-08-03T14:50:26.995Z",
                    "size": 24115129,
                    "type": "file"
                },
                {
                    "name": "insecta.d3.json",
                    "birthtime": "2018-08-03T20:18:13.183Z",
                    "size": 66731320,
                    "type": "file"
                },
                {
                    "name": "hymenoptera.d3.json",
                    "birthtime": "2018-08-03T14:52:09.615Z",
                    "size": 12169249,
                    "type": "file"
                },
                {
                    "name": "chondrichthyes.d3.json",
                    "birthtime": "2018-08-03T16:50:02.663Z",
                    "size": 1348372,
                    "type": "file"
                },
                {
                    "name": "tetrapoda.d3.json",
                    "birthtime": "2018-08-03T12:18:14.707Z",
                    "size": 93837151,
                    "type": "file"
                },
                {
                    "name": "aves.d3.json",
                    "birthtime": "2018-08-03T14:52:20.199Z",
                    "size": 14493059,
                    "type": "file"
                },
                {
                    "name": "mammalia.d3.json",
                    "birthtime": "2018-08-03T12:18:20.051Z",
                    "size": 13443633,
                    "type": "file"
                },
                {
                    "name": "metatheria.d3.json",
                    "birthtime": "2018-08-03T12:18:20.055Z",
                    "size": 521794,
                    "type": "file"
                },
                {
                    "name": "xenarthra.d3.json",
                    "birthtime": "2018-08-03T21:23:37.506Z",
                    "size": 119145,
                    "type": "file"
                },
                {
                    "name": "laurasiatheria.d3.json",
                    "birthtime": "2018-08-03T16:42:26.820Z",
                    "size": 4863836,
                    "type": "file"
                },
                {
                    "name": "carnivora.d3.json",
                    "birthtime": "2018-08-03T16:42:15.564Z",
                    "size": 467474,
                    "type": "file"
                },
                {
                    "name": "sciuridae.d3.json",
                    "birthtime": "2018-08-03T20:18:23.623Z",
                    "size": 433706,
                    "type": "file"
                },
                {
                    "name": "primates.d3.json",
                    "birthtime": "2018-08-03T12:18:27.943Z",
                    "size": 681241,
                    "type": "file"
                },
            ]
        }
    ]
};



//////////////////
// WEBPACK FOOTER
// ./dist/js/models/navigation/demos-fs.js
// module id = 1036
// module chunks = 0